// Create a provider for component to consume and subscribe to changes
import React from 'react'
import { ContextProvider } from './index'

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: any) => <ContextProvider>{props.children}</ContextProvider>
